app.service('basketServiceReminder', function (console, loading, modal, log, pageConfig, updateExcludedServices, updateServicePrices, broker) {
	var $self, $form, $actionInput, $serviceInput, $servicesToAdd, $servicesQuantityOnModal, $servicesOnModal, $summary, $addServicesButton;
	var reminderModal;

	function open() {
		if (!reminderModal) {
			reminderModal = modal.open('service-to-add-reminder');
		} else {
			reminderModal.open();
		}
	}
	function destroyModalServiceReminder() {
		reminderModal = false;
		modal.destroy('service-to-add-reminder');
	}
	function submit() {
		loading.start();
		modal.close();
		$form.submit();
	}
	function logToCartEvent(servicesEventArray){
		var basket = pageConfig.getData('basket');
		if (servicesEventArray.length){
			servicesEventArray.forEach(function(service) {
				log.event({
					id: 'to_cart',
					f03: 'cart_step_1',
					f04: service.servicePlu,
					f05: 'service',
					f06: service.productPlu,
					f07: 'services_box',
					f08: 'fancybox',
					f09: 'new',
					f10: basket.items.filter(item => item.plu == service.productPlu)[0].isInstalmentPrice ? 'installment' : 'cash',
				});
			})
		}
	}
	function addServices() {
		var checkedServices = [];
		var logEventServicesData = []
		$servicesOnModal.filter(':checked').each(function () {
			var product = $(this).data('product');
			var service = $(this).data('service');
			var quantity = $(this).data('quantity');
			toggleService(product, service);
			logEventServicesData.push({
				productPlu: $(this).data('product-plu'),
				servicePlu: $(this).data('service-plu'),
				quantity: $(this).data('quantity')
			})
			checkedServices.push(product + '|' + service + '|' + quantity);
		});
		if (checkedServices.length) {
			$actionInput.val('ADD_SELECTED_SERVICES');
			$serviceInput.val(checkedServices.join(','));
			logToCartEvent(logEventServicesData);
			submit();
		} else {
			skip();
		}
	}
	function skip() {
		$actionInput.val('REMOVE_SELECTED_SERVICES');
		submit();
	}

	function setButtonStatus() {
		if ($servicesOnModal.filter(':checked').length) {
			$addServicesButton.prop('disabled', false);
		} else {
			$addServicesButton.prop('disabled', true);
		}
	}

	function toggleService(product, service) {
		var $service = $servicesToAdd.filter('[data-product=' + product + ']').filter('[data-service=' + service + ']');
		$service.prop('checked', !$service.prop('checked'));
	}
	function changeQuantity(value, productId, serviceId){
		let $service = $servicesOnModal.filter('[data-product='+productId/1+']').filter('[data-service='+serviceId+']');
		if($service.length){
			$service.attr('data-quantity', value);
		} else {
			console.log('Brak usługi do zmiany')
		}
	}
	function setElements() {
		$self = $('#modal-service-to-add-reminder');
		$form = $('form', $self);
		$summary = $('.js-services-summary-price', $self);
		$actionInput = $('#action', $form);
		$serviceInput = $('#services', $form);
		$servicesOnModal = $('.js-service', $form);
		$servicesQuantityOnModal = $('.js-service-modal-quantity', $form);
		$servicesToAdd = $('.js-services-checkbox');
		$addServicesButton = $('.js-add-services', $form);
	}
	function setEvents() {
		$('.remodal-close', $self).on('click', function () {
			skip();
		});
		$('.js-add-services', $self).on('click', function () {
			addServices();
		});
		$('.js-skip', $self).on('click', function () {
			skip();
		});
		broker.on('REFRESH_BASKET_VIEW', function () {
			destroyModalServiceReminder();
		});
		broker.on('REMOVE_ALL_MODALS',  function () {
			destroyModalServiceReminder();
		});
		$servicesQuantityOnModal.on('change', function () {
			changeQuantity($(this).val(), $(this).data('product'), $(this).data('service'));
			updateServicePrices.run({
				$inputs: $servicesOnModal,
				$box: $summary
			});
		});
		$servicesOnModal.on('click', function () {
			updateExcludedServices.run({
				$input: $(this),
				$inputs: $servicesOnModal
			});
			updateServicePrices.run({
				$inputs: $servicesOnModal,
				$box: $summary
			});
			setButtonStatus();
		});
	}
	function init() {
		setElements();
		setEvents();
	}
	return {
		init,
		open
	};
});